import { render, staticRenderFns } from "./TabProjects.vue?vue&type=template&id=c7327c50&scoped=true"
import script from "./TabProjects.vue?vue&type=script&lang=js"
export * from "./TabProjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7327c50",
  null
  
)

export default component.exports